<div class="email-flow-page flex-column f-1-0 bs-enabled">

	<!--loader-->
	<div class="flex-column centralize f-1-0" *ngIf="loading">
		<loader class="opacity-75" height="100" width="100"></loader>
	</div>

	<!--load error-->
	<div class="flex-column centralize f-1-0 gap-3 text-center" *ngIf="!loading && loadError" style="padding: 60px 20px;">
		<i class="far fa-exclamation-triangle" style="font-size: 38px; color: #c97a00;"></i>
		<span style="color: #5a6675;">Could not load your email flow configuration.</span>
		<btn-c (action)="loadFlow();">Try Again</btn-c>
	</div>

	<ng-container *ngIf="!loading && flow">
		<div class="flow-panel">

			<!--panel header-->
			<div class="flow-panel-head">
				<span class="flow-dir-title">
					{{direction === 'inbound' ? 'How email reaches your organization' : 'How your email reaches the world'}}
				</span>
				<span class="f-1-0"></span>
				<ng-container *ngIf="flow.state !== 'none'">
					<span class="flow-pill plat">{{flow.platformLabel}}</span>
					<span class="flow-pill arch">{{flow.spec.archLabel}}</span>
					<span class="flow-pill ps" *ngIf="powershellManaged">PowerShell</span>
					<span class="flow-pill ok" *ngIf="flow.state === 'connected'">&#9679; Active</span>
					<span class="flow-pill warn" *ngIf="flow.state === 'partial'">Setup incomplete</span>
				</ng-container>
				<span class="flow-pill off" *ngIf="flow.state === 'none'">Not connected</span>
			</div>

			<!--connected / partial : diagram-->
			<ng-container *ngIf="flow.state !== 'none'">
				<div class="flow-diagram-holder" [ngClass]="{'dimmed' : flow.state === 'partial'}">
					<flow-diagram-c [spec]="flow.spec"></flow-diagram-c>
					<div class="flow-partial-banner" *ngIf="flow.state === 'partial'">
						<div class="flow-partial-card">
							<h3>Almost there — finish connecting</h3>
							<p>The "{{flow.spec.archLabel}}" architecture is selected but hasn't been activated yet. Complete the setup to bring this flow online.</p>
							<btn-c (action)="goToSetup();">Finish Setup</btn-c>
						</div>
					</div>

					<div class="flow-below">
						<div class="flow-steps flex-column gap-2">
							<span class="fw-bold">What happens, step by step</span>
							<div class="flow-step" *ngFor="let step of flow.spec.steps" [ngClass]="{'threat' : step.threat}">
								<span class="n">{{step.n}}</span>
								<span>{{step.t}}</span>
							</div>
							<div class="flex-row gap-2 align-items-start text-muted lh-base" style="font-size: 1em;">
								<i class="far fa-info-circle" style="margin-top: 2px;"></i>
								<span>{{flow.spec.note}}</span>
							</div>
						</div>
						<div class="flow-facts flex-column gap-2">
							<span class="fw-bold">Live configuration</span>
							<div class="flex-row justify-content-start flex-wrap" style="gap: 7px;">
								<div class="flex-row align-items-center gap-1 border rounded p-2"
									 style="background: #f4f6fa; font-size: 0.95em;"
									 *ngFor="let fact of flow.spec.facts">
									<span class="fw-bold text-muted">{{fact.k}}:</span>
									<code style="font-size: 13px;" *ngIf="fact.mono">{{fact.v}}</code>
									<span *ngIf="!fact.mono">{{fact.v}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</ng-container>

			<!--not connected : empty state-->
			<div class="flow-empty" *ngIf="flow.state === 'none'">
				<i class="fas fa-shield-alt flow-empty-shield"></i>
				<h3>{{direction === 'inbound' ? 'Inbound protection isn\'t connected yet' : 'Outbound protection isn\'t connected yet'}}</h3>
				<p *ngIf="direction === 'inbound'">
					Right now, incoming email reaches your mailboxes without {{brand}} in the flow.
					Choose the architecture that fits your environment — setup takes a few minutes.
				</p>
				<p *ngIf="direction === 'outbound'">
					Outgoing email currently leaves your organization without DLP, encryption or policy enforcement
					(emails sent through the {{brand}} add-in and web app are still protected).
					Pick the sending architecture that fits how you deliver mail.
				</p>

				<div class="flow-options" *ngIf="direction === 'inbound'">
					<div class="flow-opt">
						<h5><i class="far fa-globe"></i>MX records</h5>
						<p>Point MX to {{brand}} — threats stopped before your server.</p>
					</div>
					<div class="flow-opt">
						<h5><i class="far fa-exchange-alt"></i>Connector</h5>
						<p>Inline scanning through a smart host. MX stays unchanged.</p>
					</div>
					<div class="flow-opt">
						<h5><i class="fas fa-shield-alt"></i>API scanning</h5>
						<p>Microsoft Graph / Gmail API — mail never leaves your tenant.</p>
					</div>
				</div>
				<div class="flow-options" *ngIf="direction === 'outbound'">
					<div class="flow-opt">
						<h5><i class="fas fa-shield-alt"></i>Relay via {{brand}}</h5>
						<p>DLP, rules and encryption — sent from your verified domain.</p>
					</div>
					<div class="flow-opt">
						<h5><i class="far fa-server"></i>Relay via your MTA</h5>
						<p>{{brand}} processes; your server keeps final delivery.</p>
					</div>
					<div class="flow-opt">
						<h5><i class="far fa-copy"></i>Journaling</h5>
						<p>Monitor and analyze sent mail without changing delivery.</p>
					</div>
				</div>

				<btn-c endIcon="far fa-arrow-right" (action)="goToSetup();">
					Set Up {{direction === 'inbound' ? 'Inbound' : 'Outbound'}} Email Flow
				</btn-c>
				<div class="flow-cta-sub">
					Opens {{direction === 'inbound' ? 'Inbound Shield' : 'Outbound Shield'}} &rarr; Plan Settings &rarr; Email Flow Integration
				</div>
			</div>
		</div>
	</ng-container>
</div>
